import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Row, Col, Form, Input, Spin, Button, message } from 'antd';
import {
  resetEmail,
  resetPassword
} from './../../../../core/actions/auth';

const formItemLayout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 }
};

const buttonItemLayout = {
  wrapperCol: { span: 14, offset: 6 }
};

class UserInfoForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      firstName: '',
      lastName: '',
      email: '',
      newPassword: '',
      currentPassword: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount() {
    this.updateState();
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.profile.firstName &&
      nextProps.profile.lastName &&
      nextProps.auth.email
    ) {
      this.setState({ loading: false });
    }
    const { resetEmailError, resetEmailSuccess, resetPasswordSuccess, resetPasswordError } = nextProps.authMsgs;

    if (
      nextProps.profile.firstName !== this.state.firstName &&
      nextProps.profile.lastName !== this.state.lastName &&
      nextProps.auth.email !== this.state.email
    ) {
      this.setState({
        firstName: nextProps.profile.firstName,
        lastName: nextProps.profile.lastName,
        email: nextProps.auth.email
      });
    }

    if (resetEmailError) message.error(resetEmailError);
    if (resetEmailSuccess) {
      message.success(resetEmailSuccess);
      this.setState({ newPassword: '', currentPassword: '' });
    }
    if (resetPasswordError) message.error(resetPasswordError);
    if (resetPasswordSuccess) {
      message.success(resetPasswordSuccess);
      this.setState({ newPassword: '', currentPassword: '' });
    }
    this.setState({ loading: nextProps.authMsgs.loading });
  }
  updateState() {
    if (
      this.props.profile.firstName &&
      this.props.profile.lastName &&
      this.props.auth.email
    ) {
      this.setState({
        firstName: this.props.profile.firstName,
        lastName: this.props.profile.lastName,
        email: this.props.auth.email,
        loading: false
      });
    } else {
      this.setState({ loading: true });
    }
  }
  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();
    const credentials = this.state;

    if (this.state.email !== this.props.auth.email) {
      this.props.resetEmail(credentials);
    }
    if (this.state.newPassword.length) {
      this.props.resetPassword(credentials);
    }
  }
  render() {
    return (
      <Row>
        <Col md={{ span: 10 }} lg={{ span: 12 }}>
          <Spin tip="Loading..." spinning={this.state.loading}>
            <div className="user-info">

              <Form onSubmit={e => this.handleSubmit(e)}>
                <Form.Item {...formItemLayout} label="First Name">
                  <Input
                    name="firstName"
                    value={this.state.firstName}
                    onChange={e => this.handleChange(e)}
                  />
                </Form.Item>

                <Form.Item {...formItemLayout} label="Last Name">
                  <Input
                    name="lastName"
                    value={this.state.lastName}
                    onChange={e => this.handleChange(e)}
                  />
                </Form.Item>

                <Form.Item {...formItemLayout} label="E-mail">
                  <Input
                    name="email"
                    value={this.state.email}
                    onChange={e => this.handleChange(e)}
                  />
                </Form.Item>

                <Form.Item {...formItemLayout} label="New Password">
                  <Input.Password
                    name="newPassword"
                    value={this.state.newPassword}
                    onChange={e => this.handleChange(e)}
                    placeholder="input new password"
                  />
                </Form.Item>

                <Form.Item {...formItemLayout} label="Current Password">
                  <Input.Password
                    name="currentPassword"
                    value={this.state.currentPassword}
                    onChange={e => this.handleChange(e)}
                    placeholder="input current password"
                  />
                </Form.Item>

                <Form.Item {...buttonItemLayout} style={{ marginBottom: 0 }} className="save-button">
                  <Button htmlType="submit" type="primary">
                    Save Changes
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Spin>
        </Col>
      </Row>
    );
  }
}

const mapStateToProps = state => ({
  authMsgs: state.auth,
  profile: state.firebase.profile,
  auth: state.firebase.auth
});

const mapDispatchToProps = dispatch => ({
  resetEmail: email => dispatch(resetEmail(email)),
  resetPassword: password => dispatch(resetPassword(password))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserInfoForm);
